import type { Point } from "../shared/schema";

// Shape point anchors in the existing board format are scaled from local origin,
// not from the shape geometry's minimum. Marks can have nonzero bounds.x/y.
export function shapePointAnchor(local: Point, bounds: { w: number; h: number }) {
  return { x: local.x / (bounds.w || 1), y: local.y / (bounds.h || 1) };
}
